import { render, staticRenderFns } from "./StructureBased.vue?vue&type=template&id=ffac6f48&scoped=true"
import script from "./StructureBased.vue?vue&type=script&lang=js"
export * from "./StructureBased.vue?vue&type=script&lang=js"
import style0 from "./StructureBased.vue?vue&type=style&index=0&id=ffac6f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac6f48",
  null
  
)

export default component.exports